/* The Hedge Guys shared behaviour: drawer, package toggle, calculator */
(function () {
  'use strict';

  /* Close open nav dropdowns when clicking elsewhere */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.hg-nav-dd[open]').forEach(function (dd) {
      if (!dd.contains(e.target)) dd.removeAttribute('open');
    });
  });

  /* Mobile drawer */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-hg-drawer-open]');
    var closeBtn = e.target.closest('[data-hg-drawer-close]');
    var drawer = document.getElementById('hg-drawer');
    if (!drawer) return;
    if (openBtn) { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (closeBtn || (drawer.classList.contains('is-open') && e.target.closest('#hg-drawer a'))) {
      drawer.classList.remove('is-open'); document.body.style.overflow = '';
    }
  });

  /* Supply / installed package toggle */
  document.querySelectorAll('[data-hg-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-mode]');
      if (!btn) return;
      var mode = btn.getAttribute('data-mode');
      toggle.querySelectorAll('button').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      var scope = toggle.closest('.hg-scope') || document;
      scope.querySelectorAll('[data-hg-mode]').forEach(function (el) {
        el.classList.toggle('hg-hidden', el.getAttribute('data-hg-mode') !== mode);
      });
    });
  });

  /* Calculator */
  var calc = document.querySelector('[data-hg-calc]');
  if (calc) {
    var prices = JSON.parse(calc.getAttribute('data-prices') || '{}');
    var lengthEl = calc.querySelector('[name="hg-length"]');
    var sizeEl = calc.querySelector('[name="hg-size"]');
    var installEl = calc.querySelector('[name="hg-install"]');
    var plantsOut = calc.querySelector('[data-out="plants"]');
    var priceOut = calc.querySelector('[data-out="price"]');
    var eachOut = calc.querySelector('[data-out="each"]');
    var ctaBtn = calc.querySelector('[data-out="cta"]');

    var update = function () {
      var metres = parseFloat(lengthEl.value);
      var size = sizeEl.value;
      var install = installEl.value;
      var entry = (prices[size] || {})[install] || {};
      if (!metres || metres <= 0 || !entry.price) {
        plantsOut.textContent = '0';
        priceOut.textContent = '$0';
        eachOut.textContent = entry.price ? '$' + entry.price + ' per plant' : 'Select options';
        if (ctaBtn) { ctaBtn.setAttribute('disabled', ''); }
        return;
      }
      var plants = Math.ceil(metres) + 1;
      var total = plants * entry.price;
      plantsOut.textContent = String(plants);
      priceOut.textContent = '$' + total.toLocaleString('en-AU');
      eachOut.textContent = '$' + entry.price + ' per plant';
      if (ctaBtn) {
        ctaBtn.removeAttribute('disabled');
        ctaBtn.setAttribute('href', '/products/' + entry.handle);
        ctaBtn.textContent = 'Order ' + plants + ' plants';
      }
    };
    ['input', 'change'].forEach(function (ev) {
      calc.addEventListener(ev, update);
    });
    update();
  }

  /* Before/after carousel (delegated so it survives any DOM timing) */
  var carIndex = function (track) {
    var step = track.children[0].getBoundingClientRect().width + 18;
    return Math.max(0, Math.min(track.children.length - 1, Math.round(track.scrollLeft / step)));
  };
  var carAnim = null;
  var carDots = function (car, i) {
    car.querySelectorAll('[data-car-dot]').forEach(function (d, j) {
      d.classList.toggle('is-active', j === i);
    });
  };
  var carGo = function (car, i) {
    var track = car.querySelector('.hg-car__track');
    i = Math.max(0, Math.min(track.children.length - 1, i));
    carDots(car, i);
    var slide = track.children[i];
    var target = slide.offsetLeft - (track.clientWidth - slide.getBoundingClientRect().width) / 2;
    target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, target));
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      track.scrollLeft = target;
      return;
    }
    if (carAnim) window.cancelAnimationFrame(carAnim);
    var start = track.scrollLeft;
    var dist = target - start;
    var t0 = null;
    var DUR = 320;
    var step = function (ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / DUR);
      var ease = 1 - Math.pow(1 - p, 3);
      track.scrollLeft = start + dist * ease;
      if (p < 1) carAnim = window.requestAnimationFrame(step);
    };
    carAnim = window.requestAnimationFrame(step);
    // Frame-starved environments (background tabs, some webviews) may never tick
    // rAF: land on the target directly so navigation still works.
    window.setTimeout(function () {
      if (t0 === null) {
        window.cancelAnimationFrame(carAnim);
        track.scrollLeft = target;
      }
    }, 120);
  };
  document.addEventListener('click', function (e) {
    var car = e.target.closest('[data-hg-carousel]');
    if (!car) return;
    var track = car.querySelector('.hg-car__track');
    var dot = e.target.closest('[data-car-dot]');
    if (e.target.closest('[data-car-prev]')) carGo(car, carIndex(track) - 1);
    else if (e.target.closest('[data-car-next]')) carGo(car, carIndex(track) + 1);
    else if (dot) carGo(car, parseInt(dot.getAttribute('data-car-dot'), 10));
  });
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.classList || !track.classList.contains('hg-car__track')) return;
    var car = track.closest('[data-hg-carousel]');
    carDots(car, carIndex(track));
  }, true);
  document.addEventListener('keydown', function (e) {
    var track = e.target.closest && e.target.closest('.hg-car__track');
    if (!track) return;
    var car = track.closest('[data-hg-carousel]');
    if (e.key === 'ArrowLeft') { e.preventDefault(); carGo(car, carIndex(track) - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); carGo(car, carIndex(track) + 1); }
  });

  /* Before/after drag comparison: pointer-driven so it works with fingers,
     mouse and pen. The range input stays for keyboard and screen readers. */
  document.querySelectorAll('.hg-cmp').forEach(function (cmp) {
    var range = cmp.querySelector('.hg-cmp__range');
    if (!range) return;
    var meter = cmp.querySelector('[data-cmp-meter]');
    /* The percentage readout only appears once the user actually drags; at rest
       the badge invites the drag instead of stating a number nobody chose. */
    var touched = false;
    var set = function (v) {
      v = Math.max(0, Math.min(100, v));
      cmp.style.setProperty('--pos', v + '%');
      range.value = v;
      if (meter && touched) meter.textContent = Math.round(100 - v) + '% more private';
    };
    var setFromX = function (clientX) {
      var r = cmp.getBoundingClientRect();
      set((clientX - r.left) / r.width * 100);
    };
    var dragging = false;
    cmp.addEventListener('pointerdown', function (e) {
      /* Inside the mobile swipe row, fingers pan the carousel; only the round
         handle starts a compare drag. Mouse and pen keep drag-anywhere. */
      if (e.pointerType === 'touch'
        && cmp.closest('.hg-bagrid')
        && window.matchMedia('(max-width: 640px)').matches
        && !e.target.closest('.hg-cmp__handle')) return;
      dragging = true;
      touched = true;
      cmp.classList.add('is-touched');
      if (cmp.setPointerCapture) { try { cmp.setPointerCapture(e.pointerId); } catch (err) {} }
      setFromX(e.clientX);
    });
    cmp.addEventListener('pointermove', function (e) {
      if (dragging) setFromX(e.clientX);
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      cmp.addEventListener(ev, function () { dragging = false; });
    });
    range.addEventListener('input', function () {
      touched = true;
      cmp.classList.add('is-touched');
      set(parseFloat(range.value));
    });
    set(parseFloat(range.value));
  });

  /* Mobile gallery dots: one per card, tracking the swipe position */
  document.querySelectorAll('.hg-bagrid').forEach(function (grid) {
    var cards = Array.prototype.slice.call(grid.children);
    if (cards.length < 2) return;
    var dots = document.createElement('div');
    dots.className = 'hg-badots';
    cards.forEach(function (c, i) {
      var d = document.createElement('span');
      if (i === 0) d.className = 'is-on';
      dots.appendChild(d);
    });
    grid.parentNode.insertBefore(dots, grid.nextSibling);
    var mark = function () {
      var step = cards[0].offsetWidth + 12;
      if (step <= 12) return;
      var idx = Math.max(0, Math.min(cards.length - 1, Math.round(grid.scrollLeft / step)));
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.classList.toggle('is-on', i === idx);
      });
    };
    grid.addEventListener('scroll', mark, { passive: true });
  });

  /* Plant-count stepper on product pages: drives the hidden Dawn quantity input */
  var setProductQty = function (qty) {
    var input = document.querySelector('input[name="quantity"]');
    if (!input) return;
    input.value = qty;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };
  document.addEventListener('input', function (e) {
    if (!(e.target.hasAttribute && e.target.hasAttribute('data-hg-plants'))) return;
    var qty = Math.max(1, Math.min(500, parseInt(e.target.value, 10) || 1));
    setProductQty(qty);
  });
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-hg-plant-step]');
    if (!step) return;
    var box = document.querySelector('[data-hg-buyx]');
    if (!box) return;
    var el = box.querySelector('[data-hg-plants]');
    if (!el) return;
    el.value = Math.max(1, Math.min(500, (parseInt(el.value, 10) || 1) + parseInt(step.getAttribute('data-hg-plant-step'), 10)));
    setProductQty(el.value);
  });

  /* Sticky buy bar on product pages: plant count and ATC quantity only.
     No totals outside the cart. */
  document.addEventListener('input', function (e) {
    if (e.target.name !== 'quantity') return;
    var box = document.querySelector('[data-hg-buyx]');
    if (!box) return;
    var qty = Math.max(1, parseInt(e.target.value, 10) || 1);
    // Sticky bar lives in a separate snippet below the button, so query the document
    var sn = document.querySelector('[data-hg-psticky-note]');
    var sa = document.querySelector('[data-hg-psticky-atc]');
    if (sn) sn.textContent = qty + (qty === 1 ? ' plant' : ' plants');
    if (sa) sa.setAttribute('href', sa.getAttribute('href').replace(/quantity=\d+/, 'quantity=' + qty));
  });

  /* Scroll reveal (progressive: content stays visible if observers never fire) */
  if ('IntersectionObserver' in window) {
    var targets = document.querySelectorAll('.hg-trust__card, .hg-pkg, .hg-bacard, .hg-step, .hg-review, .hg-section .hg-center');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    targets.forEach(function (el, i) {
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      el.classList.add('hg-reveal');
      el.style.transitionDelay = (i % 3) * 70 + 'ms';
      io.observe(el);
    });
    window.setTimeout(function () {
      document.querySelectorAll('.hg-reveal:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
    }, 3000);
  }

  /* SMS photo-quote links: iOS and Android take different body syntax.
     Prefill a clear, labelled template so the customer just fills the blanks. */
  document.querySelectorAll('[data-hg-sms]').forEach(function (a) {
    var body = [
      'Hi Hedge Guys, I would like a price for a privacy hedge.',
      '',
      'Suburb or address: ',
      'Fence length (approx metres): ',
      'Email: ',
      'Supply only or installed: ',
      '',
      'I will attach a photo of my fence line.'
    ].join('\n');
    var sep = /iPhone|iPad|iPod/i.test(navigator.userAgent) ? '&' : '?';
    a.setAttribute('href', 'sms:0493728423' + sep + 'body=' + encodeURIComponent(body));
  });

  /* Prefill the quote form from screening-studio params (?vlen=&vsize=&vmode=) */
  (function () {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('vsize')) return;
    var form = document.getElementById('hg-quote-form');
    if (!form) return;
    var sizes = { starter: 'Starter 1.2m to 1.5m', premium: 'Premium 1.6m to 1.9m', ultimate: 'Ultimate 2.1m to 2.5m' };
    var len = form.querySelector('[name="contact[fence length]"]');
    if (len && params.get('vlen')) len.value = params.get('vlen');
    var service = form.querySelector('[name="contact[service]"]');
    if (service) service.value = params.get('vmode') === 'installed' ? 'Supply + install privacy hedge' : 'Supply only (I will plant them)';
    var body = form.querySelector('[name="contact[body]"]');
    var pick = sizes[params.get('vsize')];
    if (body && pick && !body.value) {
      body.value = 'Screening studio pick: ' + pick + (params.get('vlen') ? ', ' + params.get('vlen') + 'm fence line' : '') + '.';
    }
  })();

  /* Smooth scroll for same-page anchors */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var target = document.querySelector(link.getAttribute('href'));
    if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
})();
